import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import SizeModifierSection from './SizeModifierSection';
import ModifierGroup from './modifier-group';

const Sizes = ({
    size,
    size_options,
    size_modifier_group,
    display_as_checkboxes,
    onChange,
}) => {
    const onModifierClick = useCallback(
        e => {
            onChange(e.id);
        },
        [onChange]
    );

    return (
        <span>
            {display_as_checkboxes ? (
                <ModifierGroup
                    modifier_group={{
                        id: size_modifier_group.id,
                        backend_name: size_modifier_group.backend_name,
                        tags: [],
                        selection_limit: 1,
                        selection_requirement: 1,
                        selection_requirement_met: true,
                        collapsed: false,
                        name: size_modifier_group.name,
                        modifiers: size_options.map(modifier => ({
                            id: modifier.id,
                            name: modifier.name,
                            backend_name: modifier.backend_name,
                            description: '',
                            image_src: null,
                            price: modifier.price.toFloat()
                                ? modifier.price
                                : '',
                            is_default: false,
                            selection_state:
                                size.id === modifier.id ? 'on' : 'off',
                            quantity: 1,
                            quantity_limit: 1,
                            visible: modifier.visible,
                            out_of_stock: modifier.out_of_stock,
                            type: 'boolean',
                            tags: [],
                        })),
                    }}
                    onHeadingClick={() => {}}
                    onModifierClick={onModifierClick}
                    onModifierQuantityChange={() => {}}
                />
            ) : (
                <SizeModifierSection
                    currentSizeId={size?.id}
                    options={size_options}
                    onChange={onChange}
                />
            )}
        </span>
    );
};

Sizes.propTypes = {
    size: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
    }).isRequired,
    size_options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            price: PropTypes.object,
        })
    ).isRequired,
    size_modifier_group: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    display_as_checkboxes: PropTypes.bool.isRequired,
};

export default Sizes;
